/* Futurfeed — interactions (sans dépendance) */
(() => {
  'use strict';

  /* ---------- Bandeau d'annonce : un message à la fois sur mobile ---------- */
  document.querySelectorAll('[data-announce]').forEach((bar) => {
    const items = bar.querySelectorAll('.announce__item');
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      if (window.matchMedia('(min-width: 990px)').matches) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 3500);
  });

  /* ---------- Galerie produit ---------- */
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = track ? [...track.children] : [];
    const dots = gallery.querySelectorAll('.gallery__dot');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (!track || slides.length < 2) return;

    const current = () => Math.round(track.scrollLeft / track.clientWidth);
    const goTo = (index) => {
      const n = (index + slides.length) % slides.length;
      track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
    };
    const sync = () => {
      const n = current();
      dots.forEach((d, k) => d.classList.toggle('is-active', k === n));
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === n));
    };

    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });

    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => goTo(current() - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => goTo(current() + 1));
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.galleryThumb))));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') goTo(current() + 1);
      if (e.key === 'ArrowLeft') goTo(current() - 1);
    });
  });

  /* ---------- Offres Solo / Duo / Trio ---------- */
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const form = section.querySelector('[data-product-form]') || section.querySelector('form[action*="/cart/add"]');
    const idInput = section.querySelector('[data-variant-input]');
    const btnPrice = section.querySelector('[data-btn-price]');
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const offers = section.querySelectorAll('[data-offer]');

    offers.forEach((radio) => {
      radio.addEventListener('change', () => {
        offers.forEach((r) => r.closest('.offer').classList.toggle('is-selected', r.checked));
        if (idInput) idInput.value = radio.value;
        if (btnPrice) btnPrice.textContent = radio.dataset.price;
        if (stickyPrice) stickyPrice.textContent = radio.dataset.price;
        const now = section.querySelector('[data-price-now]');
        const was = section.querySelector('[data-price-was]');
        const save = section.querySelector('[data-price-save]');
        if (now) now.textContent = radio.dataset.price;
        if (was && save) {
          const hasCompare = Boolean(radio.dataset.compare);
          was.hidden = !hasCompare;
          save.hidden = !hasCompare;
          if (hasCompare) {
            was.textContent = radio.dataset.compare;
            save.textContent = `Économise ${radio.dataset.savePct} %`;
          }
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url);
      });
    });

    /* Barre d'achat fixe : visible quand le vrai bouton n'est plus à l'écran */
    const sticky = section.querySelector('[data-sticky-buy]');
    const buy = section.querySelector('[data-buy]');
    if (sticky && buy && 'IntersectionObserver' in window) {
      const footer = document.querySelector('.footer');
      let buyVisible = true;
      let footerVisible = false;
      const update = () => {
        const show = !buyVisible && !footerVisible && buy.getBoundingClientRect().top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        sticky.querySelector('button').tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(([e]) => { buyVisible = e.isIntersecting; update(); }).observe(buy);
      if (footer) new IntersectionObserver(([e]) => { footerVisible = e.isIntersecting; update(); }).observe(footer);
    }

    /* Évite le double envoi */
    form?.addEventListener('submit', () => {
      const btn = form.querySelector('[data-add]');
      if (btn) setTimeout(() => { btn.disabled = true; }, 0);
    });
    window.addEventListener('pageshow', () => {
      const btn = form?.querySelector('[data-add]');
      if (btn && !btn.dataset.soldout) btn.disabled = false;
    });
  });

  /* ---------- Date de livraison estimée (jours ouvrés) ---------- */
  document.querySelectorAll('[data-delivery]').forEach((el) => {
    const addBusinessDays = (date, days) => {
      const d = new Date(date);
      let added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        const day = d.getDay();
        if (day !== 0 && day !== 6) added += 1;
      }
      return d;
    };
    const min = Number(el.dataset.min);
    const max = Number(el.dataset.max);
    if (!min || !max) return;
    const fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
    const today = new Date();
    const target = el.querySelector('[data-delivery-range]');
    if (target) target.textContent = `entre le ${fmt.format(addBusinessDays(today, min))} et le ${fmt.format(addBusinessDays(today, max))}`;
  });

  /* ---------- Panier : + / − et mise à jour automatique ---------- */
  const cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    let timer;
    const submitUpdate = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'update';
        input.value = '1';
        cartForm.appendChild(input);
        cartForm.submit();
      }, 450);
    };
    cartForm.querySelectorAll('[data-qty-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const input = btn.parentElement.querySelector('[data-qty-input]');
        input.value = Math.max(0, Number(input.value) + Number(btn.dataset.qtyStep));
        submitUpdate();
      });
    });
    cartForm.querySelectorAll('[data-qty-input]').forEach((input) => input.addEventListener('change', submitUpdate));
  }

  /* ---------- Menu mobile : fermer en cliquant un lien ---------- */
  document.querySelectorAll('[data-menu] a').forEach((a) => {
    a.addEventListener('click', () => a.closest('details').removeAttribute('open'));
  });
})();
